import { render, staticRenderFns } from "./Grid.vue?vue&type=template&id=a13f971e&scoped=true"
import script from "./Grid.vue?vue&type=script&lang=js"
export * from "./Grid.vue?vue&type=script&lang=js"
import style0 from "./Grid.vue?vue&type=style&index=0&id=a13f971e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13f971e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a13f971e')) {
      api.createRecord('a13f971e', component.options)
    } else {
      api.reload('a13f971e', component.options)
    }
    module.hot.accept("./Grid.vue?vue&type=template&id=a13f971e&scoped=true", function () {
      api.rerender('a13f971e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Grid/Grid.vue"
export default component.exports